import { ListResponseModel, toQueryString } from ".";
import { SolarProviderOrderModel } from "../model/orders/orders";
import { ProviderBusinessInfo, SolarProviderInfoQuery } from "../model/provider/provider-dashboard-data";
import { SolarProduct } from "../model/solar-product/solar-product";
import { apiSlice } from "../stores/base/api-slice";
const adminEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getSolarProviderInformation: builder.query<ProviderBusinessInfo, SolarProviderInfoQuery>({
			query: ({ companyId, start, end }) => ({
				url: "/solar-provider/get-information" + toQueryString({ companyId, start, end }),
				method: "GET",
			}),
			providesTags: ["SolarProviderInformation"],
		}),
		toggleSolarProviderSuspention: builder.mutation<any, string>({
			query: id => ({
				url: `/solar-provider/${id}/toggle-suspensions`,
				method: "POST",
			}),
			invalidatesTags: ["SolarProviderInformation"],
		}),
		getSolarProviderProducts: builder.query<ListResponseModel<Array<SolarProduct>>, SolarProviderInfoQuery>({
			query: ({ page, pageSize, SolarProviderId }) => ({
				url: "/solar-provider/page/products" + toQueryString({ page, pageSize, SolarProviderId }),
				method: "GET",
			}),
			providesTags: ["SolarProducts"],
		}),
		getSolarProviderOrders: builder.query<ListResponseModel<Array<SolarProviderOrderModel>>, SolarProviderInfoQuery>({
			query: ({ page, pageSize, SolarProviderId, start, end }) => ({
				url: "/solar-provider/page/orders" + toQueryString({ page, pageSize, SolarProviderId, start, end }),
				method: "GET",
			}),
		}),
		pauseSolarProduct: builder.mutation<any, { id?: string; actionCode?: string | null }>({
			query: ({ id, actionCode }) => ({
				url: `/solar-product/admin/pause/${id}`,
				method: "POST",
				body: { actionCode },
			}),
			invalidatesTags: ["SolarProducts"],
		}),
		getOrderDetails: builder.query<any, string>({
			query: id => ({
				url: `/orders/${id}`,
				method: "POST",
			}),
		}),
	}),
});

export const {
	useLazyGetSolarProviderInformationQuery,
	useToggleSolarProviderSuspentionMutation,
	useLazyGetSolarProviderProductsQuery,
	useLazyGetSolarProviderOrdersQuery,
	usePauseSolarProductMutation,
} = adminEndpoints;
